export default __webpack_public_path__ + "static/media/team-member-20.2653a9cf.jpg";